import type { FetchJourneyIterationsResponseAction } from './fetchJourneyIterations';
import type { FetchMainActiveJourneyResponseAction } from './fetchMainActiveJourney';

export type ReducerAction = FetchJourneyIterationsResponseAction | FetchMainActiveJourneyResponseAction;

export * from './fetchMainActiveJourney';
export * from './fetchJourneyIterations';
